import { IHotelNameSearchItem } from "../global/types";
import { XMLHttpConfig } from "../global/XMLHttpConfig";
import { HttpService } from "../services/HttpService";

export class HotelNameSearch {
    private httpSvc: HttpService;
    private bedsId: number;
    private bedsSelector: string = "data-page-bedsid";
    private input: string = "data-hotel-name-search";
    private container: string = "data-hotel-name-search-container";
    private list: string = "data-hotel-name-search-list";
    private hasContent: boolean = false;
    private isFetchingContent: boolean = false;

    constructor() {
        this.httpSvc = new HttpService();
        this.getBedsId();
        this.bindInteractions();
    }

    private bindInteractions() {
        const input: HTMLInputElement = document.querySelector(`[${this.input}]`) as HTMLInputElement;

        if (input) {
            input.addEventListener("keyup", this.handleInputChange.bind(this));
        } 
    }

    private handleInputChange() {
        const input: HTMLInputElement = document.querySelector(`[${this.input}]`) as HTMLInputElement;
        const value = input.value;

        if (value.length >= 3) {
            if (this.hasContent === false && this.isFetchingContent === false) {
                this.requestResults(value.substring(0, 3));
                this.isFetchingContent = true;
            } else {
                this.filterContents();
            }
        } else {
            this.clearResults();
        }       
    }

    private async requestResults(value: string) {
        const url: string = `/utility/hotelnamesearch.aspx?firstcharacters=${value}&bedsnodeid=${this.bedsId}`;
        const response: any = await this.httpSvc.get(new XMLHttpConfig(url));
        this.handleRequestResponse(response);
    }

    private clearResults() {
        const list: HTMLElement = document.querySelector(`[${this.list}]`) as HTMLElement;

        list.style.display = "none";
        list.innerHTML = "";

        this.hasContent = false;
    }

    private getBedsId() {
        const beds: HTMLElement = document.querySelector(`[${this.bedsSelector}]`) as HTMLElement;
        const bedsId: string = beds.getAttribute(this.bedsSelector);

        this.bedsId = parseInt(bedsId, 10);
    }

    private filterContents() {
        const input: HTMLInputElement = document.querySelector(`[${this.input}]`) as HTMLInputElement;
        const listItems: NodeListOf<HTMLElement> = document.querySelectorAll(`[${this.list}] li`) as NodeListOf<HTMLElement>;
        const value = input.value.toUpperCase();
        let hasResults: boolean = false;

        for (let i = 0; i < listItems.length; i++) {
            if (listItems[i].innerHTML.toUpperCase().indexOf(value) > -1) {
                listItems[i].style.display = "block";
                hasResults = true;
            } else {
                listItems[i].style.display = "none";
            }
        }

        if (!hasResults) {
            this.createAndAppendNoResults();
        }
    }

    private handleRequestResponse(response: any) {
        const list: HTMLElement = document.querySelector(`[${this.list}]`) as HTMLElement;
        const responseObj: any = response;

        this.hasContent = true;
        this.isFetchingContent = false;

        list.style.display = "block";

        if (responseObj.length > 0) {
            for (let i = 0; i < responseObj.length; i++) {
                this.createAndAppendHotelResultHTML(responseObj[i]);
            }
            this.filterContents();
        } else {
            this.createAndAppendNoResults();
        }    
    }

    private createAndAppendHotelResultHTML(item: IHotelNameSearchItem) {
        const list: HTMLElement = document.querySelector(`[${this.list}]`) as HTMLElement;
        const hotelItem: HTMLElement = document.createElement("li");
        const link: HTMLElement = document.createElement("a");

        link.setAttribute("href", item.HotelURL);
        link.innerText = item.Name;

        hotelItem.appendChild(link);
        list.appendChild(hotelItem);
    }

    private createAndAppendNoResults() {
        const list: HTMLElement = document.querySelector(`[${this.list}]`) as HTMLElement;
        const hotelItem: HTMLElement = document.createElement("li");

        hotelItem.innerText = "No results match your query.";
        hotelItem.classList.add("noresults");
        list.appendChild(hotelItem);
    }

}



// WEBPACK FOOTER //
// ./src/hotels/HotelNameSearch.ts